import { create } from "@/modules/Url";

export const urlService = create();
